import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-tab', {
    staticClass: "w-75",
    attrs: {
      "title": "Outras informações",
      "active": _vm.isTheCurrentTab,
      "disabled": !_vm.isTheCurrentTab && !_vm.store.isUpdate
    },
    on: {
      "click": function click() {
        return _vm.store.currentTab = 3;
      }
    }
  }, [_c('label', [_vm._v("Data Solicitação")]), _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "data_solicitacao",
      "label-for": "data_solicitacao"
    }
  }, [_c('b-form-datepicker', {
    attrs: {
      "locale": "pt-br"
    },
    model: {
      value: _vm.form.data_solicitacao,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "data_solicitacao", $$v);
      },
      expression: "form.data_solicitacao"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Status",
      "label-for": "status"
    }
  }, [_c('VueSelect', {
    ref: "buscarStatus",
    attrs: {
      "filterable": false,
      "options": _vm.allStatus
    },
    on: {
      "input": _vm.setStatus,
      "search": _vm.onSearchStatus
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }]),
    model: {
      value: _vm.form.status,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "status", $$v);
      },
      expression: "form.status"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o status ")])], 2)], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('CentroCustoSelect', {
    model: {
      value: _vm.form.id_centro_custo,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "id_centro_custo", $$v);
      },
      expression: "form.id_centro_custo"
    }
  })], 1)], 1), _c('b-row', [_c('b-col', {}, [_c('b-form-group', {
    attrs: {
      "label": "Informações Adicionais",
      "label-for": "observacao"
    }
  }, [_c(VTextarea, {
    attrs: {
      "full-width": "",
      "no-resize": "",
      "rows": "1",
      "auto-grow": ""
    },
    model: {
      value: _vm.form.observacao,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "observacao", $$v);
      },
      expression: "form.observacao"
    }
  })], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };